export default "__VITE_ASSET__Cb8IRHzn__"